import React from "react";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Checkbox, Button
} from "@mui/material";
import { EyeIcon, ScanEye } from "lucide-react";
import dayjs from "dayjs";

const OrderTable = ({
  orders,
  setOpen,
  setSelectedData,
  setSelectedProduct,
  setOpenDetail,
  onDeliveryStatusChange  // This function is passed as a prop
}) => {
  return (
    <Paper>
      <TableContainer>
        <Table aria-labelledby="tableTitle">
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox"></TableCell>
              <TableCell align="center">Захиалагчийн нэр</TableCell>
              <TableCell align="center">Хаяг</TableCell>
              <TableCell align="center">Дугаар</TableCell>
              <TableCell align="center">Нийт Үнэ</TableCell>
              <TableCell align="center">Захиалсан огноо</TableCell>
              <TableCell align="center">Хүргэлт</TableCell>
              <TableCell align="center">Барааг харах</TableCell>
              <TableCell align="center">Бүх мэдээллийг харах</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {orders.map((row) => (
              <TableRow hover key={row._id}>
                <TableCell padding="checkbox">
                  <Checkbox color="primary" />
                </TableCell>
                <TableCell align="center">{row.firstName}</TableCell>
                <TableCell align="center">{row.address}</TableCell>
                <TableCell align="center">{row.phone}</TableCell>
                <TableCell align="center">{Intl.NumberFormat('en-us').format(row.price)}₮</TableCell>
                <TableCell align="center">{dayjs(row.createdAt).format('YYYY-MM-DD')}</TableCell>
                <TableCell align="center">
                  <Button
                    variant="contained"
                    color={row.isDelived ? "success" : "error"}
                    onClick={() => onDeliveryStatusChange(row)}  // Call the passed function when the button is clicked
                  >
                    {row.isDelived ? "Хүргэгдсэн" : "Хүргэгдээгүй"}
                  </Button>
                </TableCell>
                <TableCell align="center">
                  <ScanEye
                    size={25}
                    color="orange"
                    onClick={() => {
                      setSelectedData(row.orders);
                      setOpen(true);
                    }}
                    className="cursor-pointer"
                  />
                </TableCell>
                <TableCell align="center">
                  <EyeIcon
                    size={25}
                    color="green"
                    onClick={() => {
                      setSelectedProduct(row);
                      setOpenDetail(true);
                    }}
                    className="cursor-pointer"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default OrderTable;
